import { render, staticRenderFns } from "./QuoteProductCustomDiscountsDialog.vue?vue&type=template&id=5f2d2d28&scoped=true&"
import script from "./QuoteProductCustomDiscountsDialog.vue?vue&type=script&lang=ts&"
export * from "./QuoteProductCustomDiscountsDialog.vue?vue&type=script&lang=ts&"
import style0 from "./QuoteProductCustomDiscountsDialog.vue?vue&type=style&index=0&id=5f2d2d28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2d2d28",
  null
  
)

export default component.exports